// src/components/email/EmailForm.jsx
import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

const EmailForm = () => {
  const [newEmail, setNewEmail] = useState("");
  const [message, setMessage] = useState("");

  const addEmail = async () => {
    const res = await fetch("/api/emails", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: newEmail }),
    });
    const data = await res.json();
    if (res.ok) {
      toast.success("Email added");
      setNewEmail("");
      window.dispatchEvent(new Event("refresh-email-list"));
    } else toast.error(data.message || "Failed to add");
  };

  const sendToAll = async () => {
    const res = await fetch("/api/emails/send", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ message }),
    });
    if (res.ok) {
      toast.success("Emails sent");
      setMessage("");
    } else toast.error("Send failed");
  };

  return (
    <div className="space-y-4">
      <div className="flex gap-2">
        <Input value={newEmail} onChange={(e) => setNewEmail(e.target.value)} placeholder="Enter new email" />
        <Button onClick={addEmail}>Add Email</Button>
      </div>
      <div className="space-y-2">
        <Textarea value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Your message..." />
        <Button onClick={sendToAll}>Send to All</Button>
      </div>
    </div>
  );
};

export default EmailForm;
